/**
 * 存储服务
 */
class StorageService {
  constructor (isSession) {
    this.catchWarpper(() => {
      if (!isSession) {
        this.storage = window.localStorage;
      } else {
        this.storage = window.sessionStorage;
      }
    });
  }
  /**
   * 设置存储值
   * @param {key,value,expires} expires 过期时间
   */
  setItem ({ key, value, expires }) {
    if (typeof key !== 'string' || !key) {
      console.warn('key 的类型必须是string切不为空', key);
      return;
    }
    if (!expires || expires <= 0) {
      console.warn('过期时间小于等于0', expires);
      return;
    }
    const val = JSON.stringify({ value, expires });
    this.catchWarpper(() => this.storage && this.storage.setItem(key, val));
  }
  /**
   *  获取存储值
   * @param {*} key
   */
  getItem (key) {
    if (typeof key !== 'string' || !key) {
      console.log('key 的类型必须是string切不为空', key);
      return null;
    }
    var val = this.catchWarpper(() => this.storage && this.storage.getItem(key));
    if (val) {
      const obj = JSON.parse(val);
      if (obj.expires > new Date().getTime()) {
        return obj.value;
      }
      this.removeItem(key);
    }
    return null;
  }
  removeItem (key) {
    this.catchWarpper(() => this.storage && this.storage.removeItem(key));
  }
  catchWarpper (action) {
    try {
      if (typeof action === 'function') {
        return action();
      }
    }
    catch (error) {
      console.error(error);
    }
    return null;
  }
}
const localStorageService = new StorageService(false);
const sessionStorageService = new StorageService(true);
export { StorageService, localStorageService, sessionStorageService };
